import { render } from "./ListSubjectsPage.vue?vue&type=template&id=a8d67014&scoped=true"
import script from "./ListSubjectsPage.vue?vue&type=script&lang=js"
export * from "./ListSubjectsPage.vue?vue&type=script&lang=js"

import "./ListSubjectsPage.vue?vue&type=style&index=0&id=a8d67014&scoped=true&lang=stylus"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d67014"]])

export default __exports__